// Disable auto-bind to [data-parsley-validate]
// TODO: move the autobind declaration outside of this file, but before including parsley
// @ts-ignore
// window.ParsleyConfig = { autoBind: false };

import Parsley from 'parsleyjs';
// import Parsley from '../vendor/parsleyjs';

// Take control over the init process of parsley
// import 'parsleyjs/src/extra/plugin/bind';

import 'parsleyjs/src/extra/validator/comparison';
// import 'parsleyjs/src/extra/validator/date';
// import 'parsleyjs/src/extra/validator/dateiso';
// import 'parsleyjs/src/extra/validator/luhn';
import 'parsleyjs/src/extra/validator/notequalto';
import 'parsleyjs/src/extra/validator/words';
import './parsley-extra/password.js';
import './parsley-extra/phone-number.js';
import './parsley-extra/remote-message.js';

/**
 * Cached locales (en is loaded by default)
 */
const loadedMessages = {};
const onLocaleLoadedCallbacks = [];
let haveLocalesToLoad = false;
let localeMessagesLoaded = false;

export const onLocaleLoaded = (callback) => {
	// Execute the callback now
	if (localeMessagesLoaded === true) {
		callback(Parsley._validatorRegistry.locale);
	}
	// Add the callback to the list of callbacks
	else {
		onLocaleLoadedCallbacks.push(callback);
	}
};

const triggerLocaleLoaded = () => {
	if (localeMessagesLoaded === false) {
		localeMessagesLoaded = true;
		while (onLocaleLoadedCallbacks.length > 0) {
			onLocaleLoadedCallbacks.shift()(Parsley._validatorRegistry.locale);
		}
	}
};

/**
 * Load locale
 *
 * @param {string} langLocale
 * @param {Parsley} Parsley
 */
export const loadLocaleMessages = async (langLocale, Parsley) => {

	// this will bundle all locales into a single file /* webpackMode: "eager" */

	// Get list of current locale prefixes
	const prefixes = mpro.getCurrentLocalesFor(langLocale, 'parsleyjs');
	const prefixesToLoad = [];

	// Load locales only once
	for (const prefix of prefixes) {
		if (!loadedMessages[prefix]) {
			prefixesToLoad.push(prefix);
			loadedMessages[prefix] = true;
		}
	}

	if (prefixesToLoad.length > 0) {

		// Make sure we don't trigger callbacks too early
		haveLocalesToLoad = true;

		// Wait for all locale message files to settle
		await Promise.allSettled(prefixesToLoad.map(async (localePrefix) => {
			const messages = await import(
				/* webpackChunkName: "parsley-i18n/[request]" */
				`parsleyjs/dist/i18n/${localePrefix}.js`
			);
			// Remove parsley message when the field is empty
			// Note: The api might change in future versions
			Parsley.addMessages(Parsley._validatorRegistry.locale, {
				required: ' ',
			});
			return messages;
		}));

		// Callback when all locales are loaded
		triggerLocaleLoaded();
	}
	// No locales to load (or they were already loaded in previous calls)
	else if (!haveLocalesToLoad) {

		// Callback when all locales are loaded
		triggerLocaleLoaded();
	}
};

// Remove parsley message when the field is empty
// Note: The api might change in future versions
if (!Parsley._validatorRegistry.locale) {
	console.warn('Parsley._validatorRegistry.locale is missing! (api might have changed)');
}
Parsley.addMessages(Parsley._validatorRegistry.locale, {
	required: ' ',
});

// ----------------------------------------------------------
// --- Set custom global messages to parsley ---
// ----------------------------------------------------------

// Create a custom error message array list
Parsley.customErrorMessagesList = [];

/**
 * Set or replace the current validator type message
 * @param {string|{ [key: string]: string }} validatorName
 * @param {string?} message
 */
Parsley.setFormCustomValidationMessage = (validatorName, message) => {
	onLocaleLoaded((/** @type {string} */ currentLocale) => {

		// const currentLocale = mpro.getCurrentLocalesFor(mpro.getCurrentLocale(), 'parsleyjs')[0] || 'en';

		// Single validator message
		if (typeof validatorName === 'string') {
			// Add to custom list
			Parsley.customErrorMessagesList.push(validatorName);
			Parsley.addMessage(currentLocale, validatorName, message);
		}
		// Multiple validator messages
		else {
			// Add to custom list
			for (const [vName] of Object.entries(validatorName)) {
				Parsley.customErrorMessagesList.push(vName);
			}
			Parsley.addMessages(currentLocale, validatorName);
		}
	});
};

/**
 * @param {typeof Parsley} parsleyInstance
 * @param {string} validatorName
 */
Parsley.instanceHasCustomValidatorMessage = (parsleyInstance, validatorName) => {
	return Parsley.customErrorMessagesList.includes(validatorName) || (typeof parsleyInstance.options[`${validatorName}Message`] !== 'undefined');
};

// ----------------------------------------------------------
// ----------------------------------------------------------
// ----------------------------------------------------------

// @ts-ignore
class LocaleFactory extends Parsley.Factory {
	constructor(...args) {
		loadLocaleMessages(mpro.getCurrentLocale(), Parsley);
		super(...args);
	}
}

Parsley.Factory = LocaleFactory;

// Or we can subclass the Factory class using es5
// const origCtr = Parsley.Factory;

// Parsley.Factory = function () {
// 	// Load ParsleyJs locales
// 	loadLocaleMessages(mpro.getCurrentLocale(), Parsley);
// 	return origCtr.apply(this, arguments);
// };

// // subclass extends superclass
// Parsley.Factory.prototype = Object.create(origCtr.prototype);
// // Make sure the constructor references the child, not the parent (ResultsAdapter)
// Parsley.Factory.prototype.constructor = Parsley.Factory;

// Export the lib
// window.Parsley = Parsley;

export default Parsley;
